import { render } from "./CardChallengeResultStatWinLoss.vue?vue&type=template&id=52c25fcc&scoped=true"
import script from "./CardChallengeResultStatWinLoss.vue?vue&type=script&lang=js"
export * from "./CardChallengeResultStatWinLoss.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-result-stat-win-loss.css?vue&type=style&index=0&id=52c25fcc&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c25fcc"]])

export default __exports__